<script lang="ts">
import { lateinit } from 'tg-commons'
import { ControlPosition, type ScaleControl, type ScaleControlOptions, type WrapStringEnumValue, unwrapStringEnumValue } from 'tg-map-core'
import { defineComponent } from 'vue'
import { type Props, stringEnumProp } from '../../utils/vue-utils'
import MapMixin from '../map-mixin'
export default defineComponent({
  name: 'tg-scale-control',
  mixins: [MapMixin],
  props: {
    position: stringEnumProp(ControlPosition, ControlPosition.BOTTOM_RIGHT),
  } satisfies Props<WrapStringEnumValue<ScaleControlOptions, {
    position: typeof ControlPosition
  }>>,
  setup() {
    return {
      control: lateinit<ScaleControl>(),
    }
  },
  watch: {
    position(value) {
      this.control.setPosition(value)
    },
  },
  onCreate() {
    this.control = this.$map.createScaleControl(unwrapStringEnumValue(this))
    this.$map.addControl(this.control)
  },
  onDestroy() {
    this.$map.removeControl(this.control)
  },
})

</script>
